"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const b_1 = __importDefault(require("b_"));
const pythia_libs_1 = require("@yandex-int/pythia-libs");
const final_styles_1 = __importDefault(require("./final.styles"));
const b = b_1.default.with('final');
const FinalText = ({ theme }) => {
    const i18n = (0, pythia_libs_1.i18n)(['final']);
    if (theme === 'ugc-cab') {
        return ((0, jsx_runtime_1.jsxs)(react_2.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { children: "\u0422\u043E\u043B\u044C\u043A\u043E \u0447\u0442\u043E \u0432\u044B \u043F\u043E\u0432\u043B\u0438\u044F\u043B\u0438 \u043D\u0430 \u0431\u0443\u0434\u0443\u0449\u0438\u0439 \u0432\u0438\u0434 \u041F\u043E\u0438\u0441\u043A\u0430 \u042F\u043D\u0434\u0435\u043A\u0441\u0430" }), (0, jsx_runtime_1.jsx)("h1", { children: i18n(['thanks']) })] }));
    }
    return i18n(['thanks']);
};
function Final({ theme }) {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b({ theme }), "data-test": 'final' }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: final_styles_1.default }), (0, jsx_runtime_1.jsx)(FinalText, { theme: theme })] })));
}
exports.default = Final;
